import axios from "axios";
import {HTTP} from "../../helpers/axios";
// src/thunks.ts

import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import {serverRoutes} from "../../api/serverRoutes";

export const searchUsers = (data:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    try {

        let response=await HTTP(getState,dispatch).post(serverRoutes.searchUsers,data);

        let error=false;
        callback(error);

        dispatch({
            type: 'SEARCH_USERS',
            payload: response.data
        });
    }catch (e) {
        let error=true;
        callback(error);
    }
};

